module.exports = __webpack_public_path__ + "static/img/Frame 1857.a9bd3a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls3/Frame 1857.png
// module id = voM4
// module chunks = 12